import { CONFIG } from '../../../core/config';
import { ViewModel } from '../../view-model';
import { FactoredRemainingLifeCell } from './factored-remaining-life-cell';

export class FactoredRemainingLifeMatrix implements ViewModel {
  readonly friendlyTypeNameSingular = 'Factored Remaining Life Matrix';
  readonly apiRoute: string = CONFIG.apiRoutes.factoredRemainingLifeMatrix;

  modelId: string;
  riskMatrixId: string;
  factoredRemainingLifeCells = new Array<FactoredRemainingLifeCell>();

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.modelId = data.modelId;
    this.riskMatrixId = data.riskMatrixId;

    if (data.factoredRemainingLifeCells) {
      data.factoredRemainingLifeCells.forEach((cell: any) => {
        const newCell = new FactoredRemainingLifeCell();
        newCell.loadFromJson(cell);
        this.factoredRemainingLifeCells.push(newCell);
      });
    }
  }
}
